module.exports = "/images/na.svg?f509fa5e55e8c9895d452e1d8df61610";